import type { IAttentionStatusesItem } from '../types'

/**
 * How many raised statuses a set of rows stands for.
 *
 * A row can stand for more than one: the manager cockpit's status row stands for every partner
 * that raised it, and in `Overall` a status several offerings raised is a single row. Counters
 * over a level count raises, so `5 statuses raised` never stands over hundreds of them; the list
 * itself still lists one row per status.
 */
export const countAttentionRaises = (items: IAttentionStatusesItem[]): number =>
  items.reduce((total, { raiseCount = 1 }) => total + raiseCount, 0)
